import { effect, inject, Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ConsentService } from '../consent/consent.service';
import { environment } from '../../environments/environment';
import { ClarityService } from './clarity.service';

/**
 * Keeps Clarity Identify and GA4 user_id in sync with Supabase auth when analytics consent is granted.
 */
@Injectable({ providedIn: 'root' })
export class TelemetryAuthBridgeService {
  private readonly auth = inject(AuthService);
  private readonly clarity = inject(ClarityService);
  private readonly consent = inject(ConsentService);

  constructor() {
    effect(() => {
      const user = this.auth.user();
      // Anonymous purchase sessions are throwaway identities; identify only real accounts.
      if (!user || user.is_anonymous) {
        return;
      }

      if (this.clarity.analyticsAllowed()) {
        void this.clarity.identify(user.id, undefined, undefined, user.email ?? undefined);
      }

      const measurementId = environment.gaMeasurementId;
      const gtag = window.gtag;
      if (this.consent.analyticsAllowed() && measurementId && typeof gtag === 'function') {
        gtag('config', measurementId, { user_id: user.id });
      }
    });
  }
}
